import jwtDecode from 'jwt-decode';
import * as cookie from 'js-cookie';
import axios from 'axios';

let cachedUser:
    | boolean
    | {
          isUserAuthenticated: () => boolean;
          getRawDetails: () => {
              email: any;
              photos: any;
              displayName: any;
          } | null;
          getUserDisplayName: () => any;
          getUserEmail: () => any | string;
          getUserAvatarUrl: () => string | any;
          getCanUserEdit: () => boolean;
      } = false;
const userDetailsCallbackCache: ((value?: unknown) => void)[] = [];
let nowLoadingUserDetails = false;

const _createUserDetailsObject = (
    response: { email: any; photos: any; displayName: any } | null
) => {
    const _isUserAuthenticated = () => {
        return (
            response !== null &&
            typeof response.email === 'string' &&
            response.email.length > 0
        );
    };

    const _getUserEmail = () => {
        if (response) {
            return _isUserAuthenticated() ? response.email : '';
        }
        return '';
    };

    const _getUserAvatarUrl = () => {
        if (response) {
            if (
                !_isUserAuthenticated() ||
                !Array.isArray(response.photos) ||
                response.photos.length === 0 ||
                typeof response.photos[0].value !== 'string'
            ) {
                return '';
            }

            return response.photos[0].value;
        }
        return '';
    };

    const _getCanUserEdit = () => {
        if (!response) {
            return false;
        }

        return _isUserAuthenticated()
            ? /@atlassian.com$/.test(response.email)
            : false;
    };

    const _getRawDetails = () => {
        return response;
    };

    const _getUserDisplayName = () => {
        if (response) {
            return response.displayName;
        }
    };

    return {
        isUserAuthenticated: _isUserAuthenticated,
        getUserEmail: _getUserEmail,
        getUserAvatarUrl: _getUserAvatarUrl,
        getCanUserEdit: _getCanUserEdit,
        getRawDetails: _getRawDetails,
        getUserDisplayName: _getUserDisplayName
    };
};

const _triggerCallbacks = () => {
    for (const element of userDetailsCallbackCache) {
        element(cachedUser);
    }
};

const _getUserDetails = async (cstFlagEnabled: any): Promise<any> => {
    let decodedUser: any, apiOutput: any;
    if (!cstFlagEnabled) {
        decodedUser = jwtDecode(
            // @ts-ignore
            cookie.get(window.SAC_OIDC_TOKEN_COOKIE_NAME) as string
        );
    } else {
        let url;
        if (window.location.hostname.includes('partners')) {
            url =
                window.location.protocol +
                '//' +
                window.location.hostname +
                '/gateway/api/customer-context/user/auth';
        } else if (
            window.location.hostname === 'support.atlassian.com' ||
            window.location.hostname.includes('support.stg')
        ) {
            url =
                window.SAC_BASE_URL + '/gateway/api/customer-context/user/auth';
        } else if (window.location.hostname.includes('support.uat')) {
            url =
                'https://support.stg.internal.atlassian.com/gateway/api/customer-context/user/auth';
        } else {
            url =
                'https://support.dev.internal.atlassian.com/gateway/api/customer-context/user/auth';
        }

        apiOutput = await axios.get(url, {
            withCredentials: true,
            headers: { 'content-type': 'application/json' }
        });
    }

    return new Promise((resolve) => {
        if (cachedUser === false) {
            userDetailsCallbackCache.push(resolve);
            if (!nowLoadingUserDetails) {
                nowLoadingUserDetails = true;

                try {
                    if (cstFlagEnabled) {
                        cachedUser = _createUserDetailsObject({
                            email: apiOutput.data.userName,
                            photos: [{ value: apiOutput.data.photos[0].value }],
                            displayName: apiOutput.data.displayName
                        });
                    } else {
                        cachedUser = _createUserDetailsObject({
                            email: decodedUser.email,
                            photos: [{ value: decodedUser.picture }],
                            displayName: '' // this else condition is going away soon so no need to set it
                        });
                    }
                    _triggerCallbacks();
                } catch {
                    cachedUser = _createUserDetailsObject(null);
                    _triggerCallbacks();
                }
            }
        } else {
            resolve(cachedUser);
        }
    });
};

export default {
    getUserDetails: _getUserDetails
};
